import { useUIStore } from "../stores/ui-store"
import { keys } from "../keys"

/**
 * Returns the app dashboard URL from domains configuration.
 * Used for matter/contact profile links that should open in the dashboard.
 */
export function useDashboardUrl(): string {
  const domains = useUIStore((state) => state.domains)
  return domains?.APP || keys.APP_URL
}
